import React, { useState } from 'react';
import Sidebar from '../Shared/Sidebar';
import UploadApk from './UploadApk';
import AdminStats from './AdminStats';
import AdminTeacher from './AdminTeacher';
import AdminSubscription from './AdminSubscription';
import AdminSubscriptionAddon from './AdminSubscriptionAddon';
import AdminPlan from './AdminPlan';
import AdminFeatureCatalog from './AdminFeatureCatalog';
import AppViewer from './AppViewer';
import AdsViewer from './AdsViewer';
import SeedData from './SeedData';
import QueryExecutor from './QueryExecutor';
import PlatformCourses from './PlatformCourses';
import CouponManager from './CouponManager';
import AdminFawaterakTransaction from './AdminFawaterakTransaction';
import { AppKeys } from '../Shared/AppKeys';
import { storageHelper } from '../../Helpers/storageHelper';
import { toastHelper } from '../../Helpers/toastHelper';
import { faUpload, faBars, faTimes, faUserShield, faChartBar, faCreditCard, faPuzzlePiece, faLayerGroup, faBook, faMobileAlt, faAd, faDatabase, faTerminal, faBookOpen, faServer, faTags } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion, AnimatePresence } from 'framer-motion';

const adminMenuItems = [
  {
    id: 'stats',
    label: 'الإحصائيات',
    icon: faChartBar,
  },
  {
    id: 'teachers',
    label: 'المعلمون',
    icon: faUserShield,
  },
  {
    id: 'upload-apk',
    label: 'رفع تطبيق APK',
    icon: faUpload,
  },
  {
    id: 'subscriptions',
    label: 'الاشتراكات',
    icon: faCreditCard,
  },
  {
    id: 'subscription_addons',
    label: 'إضافات الاشتراكات',
    icon: faPuzzlePiece,
  },
  {
    id: 'plans',
    label: 'خطط الاشتراك',
    icon: faLayerGroup,
  },
  {
    id: 'feature_catalog',
    label: 'قاموس المميزات',
    icon: faBook,
  },
  {
    id: 'app_viewer',
    label: 'عروض التطبيق',
    icon: faMobileAlt,
  },
  {
    id: 'ads_viewer',
    label: 'إدارة الإعلانات',
    icon: faAd,
  },
  {
    id: 'seed_data',
    label: 'توليد بيانات (Seed)',
    icon: faDatabase,
  },
  {
    id: 'query_executor',
    label: 'منفذ الاستعلامات',
    icon: faTerminal,
  },
  {
    id: 'platform_courses',
    label: 'دورات المنصة',
    icon: faBookOpen,
  },
  {
    id: 'hangfire',
    label: 'Hangfire',
    icon: faServer,
  },
  {
    id: 'coupons',
    label: 'الكوبونات',
    icon: faTags,
  },
  {
    id: 'fawaterak_transactions',
    label: 'معاملات فواتيرك',
    icon: faCreditCard,
  },
  // You can add more admin tabs here in the future
];

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('stats');
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const isMobile = window.innerWidth <= 768;

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const openHangFireDashboard = async () => {
    try {
      if (isMobile && isSidebarOpen) {
        setSidebarOpen(false);
      }

      const token = storageHelper.getItem('token');

      if (!token) {
        toastHelper.error('Authentication token not found. Please login again.');
        return;
      }

      const cleanToken = token.startsWith('Bearer ') ? token.substring(7) : token;
      const hangfireUrl = `${AppKeys._MEDIA_URL_PRODUCTION}hangfire?jwt_token=${cleanToken}`;

      window.open(hangfireUrl, '_blank');
    } catch (error) {
      toastHelper.error('Failed to open HangFire Dashboard. Please try again.');
    }
  };

  const handleTabChange = (tabId) => {
    if (tabId === 'hangfire') {
      openHangFireDashboard();
    } else {
      setActiveTab(tabId);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'stats':
        return (
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.3 }}
          >
            <AdminStats />
          </motion.div>
        );
      case 'upload-apk':
        return (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <UploadApk />
          </motion.div>
        );
      case 'teachers':
        return (
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminTeacher />
          </motion.div>
        );
      case 'subscriptions':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminSubscription />
          </motion.div>
        );
      case 'subscription_addons':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminSubscriptionAddon />
          </motion.div>
        );
      case 'plans':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminPlan />
          </motion.div>
        );
      case 'feature_catalog':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminFeatureCatalog />
          </motion.div>
        );
      case 'app_viewer':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AppViewer />
          </motion.div>
        );
      case 'ads_viewer':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdsViewer />
          </motion.div>
        );
      case 'seed_data':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <SeedData />
          </motion.div>
        );
      case 'query_executor':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <QueryExecutor />
          </motion.div>
        );
      case 'platform_courses':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <PlatformCourses />
          </motion.div>
        );
      case 'coupons':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <CouponManager />
          </motion.div>
        );
      case 'fawaterak_transactions':
        return (
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.3 }}
          >
            <AdminFawaterakTransaction />
          </motion.div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="admin-dashboard-layout">
      <Sidebar
        isOpen={isSidebarOpen}
        onToggle={toggleSidebar}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        menuItems={adminMenuItems}
        isMobile={isMobile}
      />

      <div className={`admin-main-content ${!isSidebarOpen ? 'sidebar-closed' : ''}`}>
        {/* Header */}
        <header className="admin-header">
          <div className="header-left">
            {isMobile && (
              <button className="mobile-toggle" onClick={toggleSidebar}>
                <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
              </button>
            )}
            <div className="header-title">
              <h1>لوحة تحكم المسؤول</h1>
              <p>إدارة النظام والتطبيقات</p>
            </div>
          </div>
          <div className="header-right">
            <div className="admin-profile">
              <div className="admin-avatar">
                <FontAwesomeIcon icon={faUserShield} />
              </div>
              <span className="admin-name">Admin</span>
            </div>
          </div>
        </header>

        <div className="admin-content-wrapper">
          <AnimatePresence mode="wait">
            {renderTabContent()}
          </AnimatePresence>
        </div>
      </div>

      <style jsx>{`
        .admin-dashboard-layout {
          display: flex;
          min-height: 100vh;
          background: #F8FAFC;
            font-family: "Zain", sans-serif;
          direction: rtl;
        }

        .admin-main-content {
          flex: 1;
          margin-right: ${isMobile ? '0' : '280px'}; /* Sidebar is usually right-aligned in RTL */
          transition: margin-right 0.3s ease;
          padding: 24px;
          min-width: 0; /* Prevent overflow */
        }

        .admin-main-content.sidebar-closed {
            margin-right: ${isMobile ? '0' : '80px'};
        }

        /* Header Styles */
        .admin-header {
            background: white;
            border-radius: 16px;
            padding: 20px 30px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
        }

        .header-title h1 {
            font-size: 1.5rem;
            color: #1E293B;
            font-weight: 700;
            margin: 0 0 5px 0;
        }

        .header-title p {
            color: #64748B;
            font-size: 0.9rem;
            margin: 0;
        }

        .mobile-toggle {
            background: none;
            border: none;
            font-size: 1.2rem;
            color: #64748B;
            cursor: pointer;
            margin-left: 15px;
        }

        .admin-profile {
            display: flex;
            align-items: center;
            gap: 12px;
            background: #F1F5F9;
            padding: 8px 16px;
            border-radius: 50px;
        }

        .admin-avatar {
            width: 35px;
            height: 35px;
            background: #6366F1;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
        }

        .admin-name {
            font-weight: 600;
            color: #334155;
            font-size: 0.95rem;
        }

        .admin-content-wrapper {
            background: transparent;
        }

        @media (max-width: 768px) {
            .admin-main-content {
                margin-right: 0;
                padding: 16px;
            }
            
            .admin-header {
                padding: 15px;
                flex-direction: column;
                gap: 15px;
                align-items: flex-start;
            }
            
            .header-right {
                width: 100%;
                display: flex;
                justify-content: flex-end;
            }
        }
      `}</style>
    </div>
  );
};

export default AdminDashboard;